import request from '@/utils/request'

export function getAll() {
    return request({
        url: 'api/carInspectionStation/all',
        method: 'get'
    })
}

export default {getAll}
